import { render, staticRenderFns } from "./PortfolioSection.vue?vue&type=template&id=2232169f&scoped=true&"
import script from "./PortfolioSection.vue?vue&type=script&lang=js&"
export * from "./PortfolioSection.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioSection.vue?vue&type=style&index=0&id=2232169f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232169f",
  null
  
)

export default component.exports